(function () {
    "use strict";

    if (window.__customAbCollectionLoaded) return;
    window.__customAbCollectionLoaded = true;
    const SELECTORS = {
        root: "[data-custom-ab-root]",
        grid: "[data-custom-ab-grid]",
        footer: "[data-custom-ab-load-more]",
        button: "[data-custom-ab-load-next]",
        sentinel: "[data-custom-ab-sentinel]",
        announce: "[data-custom-ab-announce]",
        status: ".custom-ab-more__status",
        barFill: ".custom-ab-more__bar-fill",
    };

    const BUSY_CLASS = "is-loading";

    // How far below the viewport the sentinel triggers the next auto-load.
    const OBSERVER_MARGIN = "420px 0px";

    function findRoot(el) {
        return el.closest(SELECTORS.root);
    }

    function sectionIdOf(root) {
        const id = root.getAttribute("data-custom-ab-section");
        if (id) return id;
        const wrapper = root.closest('[id^="shopify-section-"]');
        return wrapper ? wrapper.id.replace("shopify-section-", "") : null;
    }

    function notifyAppended(root, added, url) {
        try {
            if (typeof window.convertCurrencies === "function") window.convertCurrencies();
        } catch (error) {
        }

        try {
            if (window.jdgm && typeof window.jdgm.reloadAll === "function") {
                window.jdgm.reloadAll();
            } else if (window.jdgmCacheServer && typeof window.jdgmCacheServer.reloadAll === "function") {
                window.jdgmCacheServer.reloadAll();
            }
        } catch (error) {
            /* review badges hydrate themselves on most stores */
        }

        document.dispatchEvent(
            new CustomEvent("custom-ab:products-appended", {
                bubbles: true,
                detail: { root: root, added: added, url: url },
            }),
        );
    }

    function updateFooter(footer, newFooter) {
        if (!newFooter) {
            footer.remove();
            return;
        }

        // 1) The "Showing X of Y" line.
        const status = footer.querySelector(SELECTORS.status);
        const newStatus = newFooter.querySelector(SELECTORS.status);
        if (status && newStatus) status.innerHTML = newStatus.innerHTML;

        // 2) The progress bar width (transitions because it's the same node).
        const fill = footer.querySelector(SELECTORS.barFill);
        const newFill = newFooter.querySelector(SELECTORS.barFill);
        if (fill && newFill) {
            fill.style.setProperty("--custom-ab-more-pct", newFill.style.getPropertyValue("--custom-ab-more-pct") || "100%");
        }

        // 3) The button: retarget it, or remove it after the last page.
        const button = footer.querySelector(SELECTORS.button);
        const newButton = newFooter.querySelector(SELECTORS.button);

        if (button && newButton) {
            // More pages remain — point the same button at the next one.
            button.href = newButton.href;
            button.removeAttribute("aria-disabled");
        } else if (button) {
            // That was the last page. Hand focus somewhere sensible first.
            if (document.activeElement === button && status) {
                status.setAttribute("tabindex", "-1");
                status.focus();
            }
            const sentinel = footer.querySelector(SELECTORS.sentinel);
            if (sentinel) sentinel.remove();
            button.remove();
        }
    }

    function loadNextPage(button, isAuto) {
        const root = findRoot(button);
        const footer = button.closest(SELECTORS.footer);
        if (!root || !footer || root.__customAbBusy) return;

        const grid = root.querySelector(SELECTORS.grid);
        const sectionId = sectionIdOf(root);
        const url = button.href;
        if (!grid || !sectionId || !url) {
            window.location.href = url;
            return;
        }

        root.__customAbBusy = true;
        footer.classList.add(BUSY_CLASS);
        button.setAttribute("aria-disabled", "true");

        const fetchUrl = new URL(url, window.location.origin);
        fetchUrl.searchParams.set("section_id", sectionId);

        fetch(fetchUrl.toString(), { headers: { "X-Requested-With": "XMLHttpRequest" } })
            .then(function (response) {
                if (!response.ok) throw new Error("Section render failed: " + response.status);
                return response.text();
            })
            .then(function (html) {
                const parsed = new DOMParser().parseFromString(html, "text/html");
                const newGrid = parsed.querySelector(SELECTORS.grid);
                const newFooter = parsed.querySelector(SELECTORS.footer);

                if (!newGrid) throw new Error("No grid in response");

                const added = Array.from(newGrid.children);
                added.forEach(function (card, index) {
                    card.classList.add("custom-ab-card--enter");
                    card.style.setProperty("--custom-ab-enter-delay", Math.min(index, 7) * 30 + "ms");
                    card.addEventListener(
                        "animationend",
                        function () {
                            card.classList.remove("custom-ab-card--enter");
                            card.style.removeProperty("--custom-ab-enter-delay");
                        },
                        { once: true },
                    );
                    grid.appendChild(card);
                });

                updateFooter(footer, newFooter);

                // Tell screen readers what just happened.
                const announcer = footer.querySelector(SELECTORS.announce);
                const status = footer.querySelector(SELECTORS.status);
                if (announcer) {
                    let message = "Loaded " + added.length + " more products.";
                    if (status) message += " " + status.textContent.replace(/\s+/g, " ").trim();
                    announcer.textContent = message;
                }

                notifyAppended(root, added, url);

                // Infinite mode: the first manual click arms hands-free loading.
                if (!isAuto && footer.getAttribute("data-custom-ab-mode") === "infinite") {
                    root.__customAbAutoArmed = true;
                }
                armAuto(root);
            })
            .catch(function () {
                // Never strand the shopper — fall back to real pagination.
                window.location.href = url;
            })
            .finally(function () {
                root.__customAbBusy = false;
                const liveFooter = root.querySelector(SELECTORS.footer);
                if (liveFooter) liveFooter.classList.remove(BUSY_CLASS);
            });
    }

    function armAuto(root) {
        if (root.__customAbObserver) {
            root.__customAbObserver.disconnect();
            root.__customAbObserver = null;
        }

        if (!root.__customAbAutoArmed) return;
        if (typeof IntersectionObserver === "undefined") return;

        const sentinel = root.querySelector(SELECTORS.sentinel);
        if (!sentinel) return; // last page reached — nothing left to watch

        const observer = new IntersectionObserver(
            function (entries) {
                entries.forEach(function (entry) {
                    if (!entry.isIntersecting || root.__customAbBusy) return;
                    const button = root.querySelector(SELECTORS.button);
                    if (button) loadNextPage(button, true);
                });
            },
            { rootMargin: OBSERVER_MARGIN },
        );

        observer.observe(sentinel);
        root.__customAbObserver = observer;
    }

    function disarmAuto(root) {
        root.__customAbAutoArmed = false;
        if (root.__customAbObserver) {
            root.__customAbObserver.disconnect();
            root.__customAbObserver = null;
        }
    }

    document.addEventListener(
        "click",
        function (event) {
            const target = event.target;
            if (!target || !target.closest) return;

            const button = target.closest(SELECTORS.button);
            if (!button) return;

            event.preventDefault();
            event.stopPropagation();
            loadNextPage(button, false);
        },
        true,
    );

    document.addEventListener("custom-ab:updated", function (event) {
        const root = event.detail && event.detail.root;
        if (root) disarmAuto(root);
    });
})();
